const HotelPerLocation = () => import('@/views/market/accommodations/HotelPerLocation')
const HotelName = () => import('@/views/market/accommodations/HotelName')
const HotelType = () => import('@/views/market/accommodations/HotelType')

const TravelAgents = () => import('@/views/market/service/TravelAgents')

const NumberFights = () => import('@/views/market/transport/NumberFights')
const NumberPassengers = () => import('@/views/market/transport/NumberPassengers')

const  ActivitiesMonth = () => import('@/views/market/event/ActivitiesMonth')

const mainWidget = [
  {
    title: 'แผนที่แสดงจำนวนสถานพักแรมในแต่ละพื้นที่',
    path: '/admin/widget/:category/:widget_code(52)',
    component: HotelPerLocation,
  },
  {
    title: 'รายชื่อสถานพักแรม',
    path: '/admin/widget/:category/:widget_code(53)',
    component: HotelName,
  },
  {
    title: 'กราฟแสดงสัดส่วนประเภทสถานพักแรม',
    path: '/admin/widget/:category/:widget_code(54)',
    component: HotelType,
  },
  {
    title: 'รายชื่อผู้ให้บริการด้านท่องเที่ยว',
    path: '/admin/widget/:category/:widget_code(65)',
    component: TravelAgents,
  },
  {
    title: 'จำนวนเที่ยวบินและที่นั่ง',
    path: '/admin/widget/:category/:widget_code(70)',
    component: NumberFights,
  },
  {
    title: 'จำนวนผู้โดยสารเดินทางเข้าออกประเทศ รายวัน จำแนกรายสนามบิน',
    path: '/admin/widget/:category/:widget_code(72)',
    component: NumberPassengers,
  },
  // {
  //   title: 'สัดส่วนปริมาณผู้โดยสารแต่ละสนามบิน',
  //   path: '/admin/widget/:category/:widget_code(73)',
  //   component: ,
  // },
  {
    title: 'รายชื่อกิจกรรมการท่องเที่ยวในแต่ละพื้นที่',
    path: '/admin/widget/:category/:widget_code(82)',
    component: ActivitiesMonth,
  }
]

export default mainWidget.map(data => {
  const { path, title, component, redirect, children } = data

  return {
    path: path,
    name: title,
    component: component,
    redirect: redirect,
    meta: {
      title: title,
      requiresAuth: true,
      breadcrumb: title
    },
    children: children
  }
})